export default "__VITE_ASSET__NXyoKUg6__"